import React, { useState, useEffect, useContext, useRef, useMemo, useCallback } from 'react';
import { TableContext } from '../../context';
import { McTabBar } from "@maersk-global/mds-react-wrapper/components-core/mc-tab-bar";
import { McTab } from "@maersk-global/mds-react-wrapper/components-core/mc-tab";
import { GoPencil } from 'react-icons/go';
import { Box, Typography, CircularProgress } from '@mui/material';
import { KeyboardArrowDown as KeyboardArrowDownIcon, KeyboardArrowUp as KeyboardArrowUpIcon } from '@mui/icons-material';
import LandingPageTable from './components/LandingPageTable';
import CiInfoDrawer from "../CiInfoDrawer";
import ChangeDetailsDrawer from "../ChangeDetailsDrawer";
import DeploymentDetailsDrawer from "../DeploymentDetailsDrawer";
import ChangesDrawer, { useChangesDrawer } from "./components/ChangesDrawer";
import ChangeSummaryCard from "./components/ChangeSummaryCard";
import ApplicationsDrawer, { useApplicationsDrawer } from "./components/ApplicationsDrawer";
import IncidentsDrawer, { useIncidentsDrawer } from "./components/IncidentsDrawer";
import IncidentsOverviewDrawer from "./components/IncidentsOverviewDrawer";
import RedChannelDrawer from "./components/RedChannelDrawer";
import InsightsSidebar from "./components/InsightsSidebar";
import LandingDashboardCard from "./components/LandingDashboardCard";
import LandingOnboardingRequestsTable from "./components/LandingOnboardingRequestsTable";
import { McTypeahead } from "@maersk-global/mds-react-wrapper/components-core/mc-typeahead";
import { McIcon } from "@maersk-global/mds-react-wrapper/components-core/mc-icon";
import ConflictsSummaryCard from "./components/ConflictsSummaryCard";
import IncidentsSummaryCard from "./components/IncidentsSummaryCard";
// import SubscriptionManagement from "../SubscriptionManagement.jsx";
import {
  fetchUserDetailsApi,
  fetchUserSuggestionsApi,
  fetchSinglePortfolioApi,
  fetchSinglePlatformApi
} from './apiHelpers';
import {
  MAERSK_FONT_FAMILY,
  INITIAL_SUCCESS_RATE,
  INITIAL_OVERDUE_CHANGES,
  INITIAL_CONFLICTING_CHANGES,
  INITIAL_INCIDENTS,
  INITIAL_USER_DETAILS,
  TIME_FILTER_OPTIONS,
  APPLICATION_VIEW_LABELS
} from './constants';
import {
  resolveChangesData,
  transformChangesToTableData,
  buildIncidentsAggregate,
  getApplicationOverviewCopy,
  getApplicationsBlankState,
  getApplicationViewOptions
} from './utils';
// Define the Maersk font family
const maerskFontFamily = MAERSK_FONT_FAMILY;

const LandingPage = () => {
  const { graphData, tokenFetched } = useContext(TableContext);

  const [inputNameValue, setInputNameValue] = useState("");
  const [inputNameValue1, setInputNameValue1] = useState("");
  const [suggestions, setSuggestions] = useState(null);
  const [suggestionClicked, setSuggestionClicked] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [edit, setEdit] = useState(true);
  const [spinnerDisplay, setSpinnerDisplay] = useState(false);
  const [isClearing, setIsClearing] = useState(false);

  const [successRate, setSuccessRate] = useState(INITIAL_SUCCESS_RATE);
  const [overdueChanges, setOverdueChanges] = useState(INITIAL_OVERDUE_CHANGES);
  const [conflictingChanges, setConflictingChanges] = useState(INITIAL_CONFLICTING_CHANGES);
  const [incidentsData, setIncidentsData] = useState(INITIAL_INCIDENTS);
  const [latestChangesSnapshot, setLatestChangesSnapshot] = useState(null);
  const [incidentsDetail, setIncidentsDetail] = useState(null);
  const [incidentTab, setIncidentTab] = useState('p1');
  const [activeLandingCard, setActiveLandingCard] = useState('changes');

  const [userDetails, setUserDetails] = useState(INITIAL_USER_DETAILS);
  const [apiData, setApiData] = useState(null);
  const [tableDataForDisplay, setTableDataForDisplay] = useState([]);

  const [viewType, setViewType] = useState("applications");
  const [selectedPlatform, setSelectedPlatform] = useState("");
  const [selectedPortfolio, setSelectedPortfolio] = useState("");
  const [timeFilter, setTimeFilter] = useState("ongoing");
  const [isLoadingData, setIsLoadingData] = useState(true);
  const [platformDropdownOpen, setPlatformDropdownOpen] = useState(false);
  const [portfolioDropdownOpen, setPortfolioDropdownOpen] = useState(false);
  const [applicationViewDropdownOpen, setApplicationViewDropdownOpen] = useState(false);
  const platformDropdownRef = useRef(null);
  const portfolioDropdownRef = useRef(null);
  const applicationViewDropdownRef = useRef(null);

  const [applicationView, setApplicationView] = useState("consolidated");

  const [isdrawerOpen, setisdrawerOpen] = useState(false);
  const [drawerCi, setDrawerCi] = useState("");
  const [drawerCiCategory, setDrawerCiCategory] = useState("");
  const [drawerType, setDrawerType] = useState("ci_info");
  const [drawerChange, setDrawerChange] = useState("");

  const [isApplicationsDrawerOpen, setIsApplicationsDrawerOpen] = useState(false);
  const [applicationsDrawerContent, setApplicationsDrawerContent] = useState([]);
  const [applicationsDrawerHeading, setApplicationsDrawerHeading] = useState("");

  const [isChangesDrawerOpen, setIsChangesDrawerOpen] = useState(false);
  const [changesDrawerContent, setChangesDrawerContent] = useState([]);
  const [changesDrawerHeading, setChangesDrawerHeading] = useState("");
  const [originalChangesContent, setOriginalChangesContent] = useState(null);
  const [originalChangesHeading, setOriginalChangesHeading] = useState("");
  const [originalChangeType, setOriginalChangeType] = useState("");

  const [isLoadingPlatformData, setIsLoadingPlatformData] = useState(false);
  const [isLoadingPortfolioData, setIsLoadingPortfolioData] = useState(false);

  const [isIncidentsDrawerOpen, setIsIncidentsDrawerOpen] = useState(false);
  const [incidentsDrawerContent, setIncidentsDrawerContent] = useState([]);
  const [incidentsDrawerHeading, setIncidentsDrawerHeading] = useState("");
  const [isIncidentsOverviewDrawerOpen, setIsIncidentsOverviewDrawerOpen] = useState(false);
  const [incidentsOverviewTab, setIncidentsOverviewTab] = useState('p1');
  const [isRedChannelDrawerOpen, setIsRedChannelDrawerOpen] = useState(false);
  
  const [pendingApprovalsCount, setPendingApprovalsCount] = useState(0);
  const [redChannelApplications, setRedChannelApplications] = useState([]);

  const onboardingRequestsCount = pendingApprovalsCount;
  const canOpenOnboardingCard = edit && onboardingRequestsCount > 0;
  /* const subscriptionListsCount = useMemo(() => (
    Object.keys(userDetails.subscribedViaListApplications || {}).length
  ), [userDetails.subscribedViaListApplications]);
  const subscribedAppsCount = useMemo(() =>
    (userDetails.subscribedApplications || []).length,
  [userDetails.subscribedApplications]); */
  const redChannelAppsCount = redChannelApplications.length;
  /* const [shouldRenderSubscriptionManagement, setShouldRenderSubscriptionManagement] = useState(false);
  const [isSubscriptionManagementLoading, setIsSubscriptionManagementLoading] = useState(false); */
  const applicationCardContentSx = {
    backgroundColor: '#fff',
    border: '1px solid #e5e7eb',
    borderRadius: 2,
    p: 3
  };

  const resetDisplayState = () => {
    setSuccessRate(INITIAL_SUCCESS_RATE);
    setOverdueChanges(INITIAL_OVERDUE_CHANGES);
    setConflictingChanges(INITIAL_CONFLICTING_CHANGES);
    setIncidentsData(INITIAL_INCIDENTS);
    setLatestChangesSnapshot(null);
    setIncidentsDetail(null);
    setTableDataForDisplay([]);
  };

  const updateDisplayData = ({
    data = apiData,
    currentViewType = viewType,
    currentTimeFilter = timeFilter,
    platformName = selectedPlatform,
    portfolioName = selectedPortfolio,
    currentApplicationView = applicationView
  } = {}) => {
    if (!data) {
      resetDisplayState();
      return;
    }

    const { changesData, incidentsInfo } = resolveChangesData({
      data,
      viewType: currentViewType,
      applicationView: currentApplicationView,
      platformName,
      portfolioName
    });

    if (!changesData) {
      resetDisplayState();
      return;
    }

    setLatestChangesSnapshot(changesData);
    setIncidentsDetail(incidentsInfo || null);

    const successCount = changesData.success_status?.successful_changes?.count || 0;
    const failureCount = changesData.success_status?.failed_changes?.count || 0;
    const ongoingCount = changesData.success_status?.ongoing_status_changes?.count || 0;

    setSuccessRate({
      success: successCount,
      failure: failureCount,
      ongoing: ongoingCount,
      total: successCount + failureCount + ongoingCount
    });

    const overdueCount = changesData.overdue_changes?.count || 0;
    setOverdueChanges({
      overdue: overdueCount,
      total: overdueCount
    });

    const conflictsCount = changesData.conflicting_changes?.conflict_groups?.length || 0;
    setConflictingChanges({
      conflicts: conflictsCount,
      total: conflictsCount
    });

    setIncidentsData(buildIncidentsAggregate(incidentsInfo));

    let tableChanges = [];
    if (currentTimeFilter === "past") {
      tableChanges = changesData.past_changes || [];
    } else if (currentTimeFilter === "future") {
      tableChanges = changesData.future_changes || [];
    } else {
      tableChanges = changesData.ongoing_changes || [];
    }

    setTableDataForDisplay(transformChangesToTableData(tableChanges));
  };


  const conflictPreviewGroups = useMemo(() => {
    if (!latestChangesSnapshot?.conflicting_changes) return [];
    const { conflict_groups = [], changes = [] } = latestChangesSnapshot.conflicting_changes;

    return conflict_groups.slice(0, 3).map((group = {}) => {
      const changeNumbers = group.conflicting_changes || [];
      const changeEntries = changeNumbers
        .map((number) => changes.find((change) => change.change_number === number))
        .filter(Boolean);

      return {
        id: group.group_id || changeNumbers.join('-') || Math.random().toString(36),
        changeNumbers,
        changeEntries
      };
    });
  }, [latestChangesSnapshot]);

  const incidentCounts = {
    p1: incidentsData.p1 || 0,
    p2: incidentsData.p2 || 0,
    p3: incidentsData.p3 || 0,
    p4: incidentsData.p4 || 0
  };
  const incidentsTotal = incidentsData.total || 0;
  const conflictsTotal = conflictingChanges.total || 0;

  const changeCardTitle = viewType === 'applications'
    ? (edit ? 'MY CHANGES' : "USER'S CHANGES")
    : 'TOTAL CHANGES';
  const changeCardSubtitle = viewType === 'applications'
    ? (edit ? 'Past & Upcoming 30 days' : `For ${inputNameValue1 || 'selected user'}`)
    : 'Past & Upcoming 30 days';
  const isChangeCardInteractive = ['applications', 'platforms', 'portfolios'].includes(viewType);

  const incidentLabelMap = {
    p1: 'P1',
    p2: 'P2',
    p3: 'P3',
    p4: 'P4'
  };

  const handleIncidentTabChange = (_event, value) => {
    setIncidentTab(value);
  };

  const getUserDetails = async (userName, userEmail) => {
    setIsLoadingData(true);
    try {
      const data = await fetchUserDetailsApi({ userName, userEmail });
      setApiData(data);

      const ownedCount = data.applications?.length || 0;
      const subscribedCount = data.subscribed_applications?.length || 0;
      const listAppsSet = new Set();
      Object.values(data.subscribed_via_list_applications || {}).forEach((apps = []) => {
        apps.forEach((app) => listAppsSet.add(app));
      });
      const totalAppsCount = ownedCount + subscribedCount + listAppsSet.size;

      setUserDetails({
        applications: data.applications || [],
        subscribedApplications: data.subscribed_applications || [],
        subscribedViaListApplications: data.subscribed_via_list_applications || {},
        platforms: data.platform || [],
        portfolios: data.portfolio || [],
        applicationsCount: totalAppsCount,
        platformsCount: data.platform?.length || 0,
        portfoliosCount: data.portfolio?.length || 0
      });

      // Extract landing page data
      const landingPageData = data.user_landing_page_data || {};
      setPendingApprovalsCount(landingPageData.pending_approvals_count || 0);
      
      // Process red channel applications
      const redChannelAppsObj = landingPageData.red_channel_applications;
      if (Array.isArray(redChannelAppsObj)) {
        // Empty list case
        setRedChannelApplications([]);
      } else if (redChannelAppsObj && typeof redChannelAppsObj === 'object') {
        // Object with application IDs as keys mapping to arrays of instance names
        const allRedChannelApps = Object.entries(redChannelAppsObj).map(([appId, instances]) => ({
          applicationId: appId,
          instances: Array.isArray(instances) ? instances : []
        }));
        setRedChannelApplications(allRedChannelApps);
      } else {
        setRedChannelApplications([]);
      }

      const hasAnyApplications = totalAppsCount > 0;
      const hasPlatforms = data.platform && data.platform.length > 0;
      const hasPortfolios = data.portfolio && data.portfolio.length > 0;

      let currentViewType = viewType;

      if (!hasAnyApplications && hasPlatforms && viewType === "applications") {
        currentViewType = "platforms";
        setViewType("platforms");
      } else if (!hasAnyApplications && !hasPlatforms && hasPortfolios && viewType === "applications") {
        currentViewType = "portfolios";
        setViewType("portfolios");
      }

      const defaultPlatform = data.platform?.[0] || "";
      const defaultPortfolio = data.portfolio?.[0] || "";

      if (defaultPlatform) {
        setSelectedPlatform(defaultPlatform);
      }
      if (defaultPortfolio) {
        setSelectedPortfolio(defaultPortfolio);
      }

      updateDisplayData({
        data,
        currentViewType,
        currentTimeFilter: timeFilter,
        platformName: defaultPlatform,
        portfolioName: defaultPortfolio,
        currentApplicationView: applicationView
      });
    } catch (error) {
      console.error('Error fetching user details:', error);
      setUserDetails(INITIAL_USER_DETAILS);
      setApiData(null);
      resetDisplayState();
      setPendingApprovalsCount(0);
      setRedChannelApplications([]);
    } finally {
      setIsLoadingData(false);
    }
  };

  const fetchUserData = async (userName) => {
    try {
      if (!userName || userName.length < 2) {
        setSuggestions(null);
       
        return;
      }

      const apiResponse = await fetchUserSuggestionsApi(userName);

      if (apiResponse.status === 200) {
        // Transform the response to match the expected format
        // const transformedSuggestions = apiResponse.data.map(user => ({
        //   displayName: user.name,
        //   email: user.email,
        //   userName: user.user_name,
        //   sysId: user.sys_id
        // }));
        setSuggestions(apiResponse.data || []);
      } else {
        setSuggestions([]);
      }
    } catch (error) {
      console.error('Error fetching user suggestions:', error);
      setSuggestions(null);
    }
  };

const fetchSinglePortfolioData = async (portfolioName) => {
  try {
    const result = await fetchSinglePortfolioApi(portfolioName);
    console.log('Portfolio API response:', result);

    if (!result?.data) {
      throw new Error("Missing data field in response");
    }

    return result;

  } catch (error) {
    console.error("Error fetching portfolio data:", error);
    return null;
  }
};

const fetchSinglePlatformData = async (platformName) => {
  try {
    const result = await fetchSinglePlatformApi(platformName);

    if (!result?.data) {
      throw new Error("Missing data field in response");
    }

    return {
      data: result.data,
      platform_incidents: result.platform_incidents
    };

  } catch (error) {
    console.error("Error fetching platform data:", error);
    return null;
  }
};



  // Load initial data when component mounts
  useEffect(() => {
    if (graphData?.displayName && graphData?.mail && tokenFetched) {
      console.log('Loading initial data for user:', graphData.displayName);
      getUserDetails(graphData.displayName, graphData.mail);
    }
  }, [tokenFetched]);

  // Debounced input change effect
  // useEffect(() => {
  //   const timeoutId = setTimeout(() => {
  //     if (inputNameValue.length >= 2 && !suggestionClicked) {
  //       fetchUserData(inputNameValue);
  //     } else if (inputNameValue.length < 2) {
  //       setSuggestions(null);
  //     }
  //   }, 500); // 500ms debounce

  //   return () => clearTimeout(timeoutId);
  // }, [inputNameValue, suggestionClicked]);

  // Debug effect to track state changes
  useEffect(() => {
    console.log('LandingPage state update:', {
      viewType,
      timeFilter,
      selectedPlatform,
      selectedPortfolio,
      tableDataLength: tableDataForDisplay?.length || 0,
      isLoadingData
    });
  }, [viewType, timeFilter, selectedPlatform, selectedPortfolio, tableDataForDisplay, isLoadingData]);

  // Debug effect to track drawer state changes
  useEffect(() => {
    console.log('Drawer state changed:', {
      isApplicationsDrawerOpen,
      applicationsDrawerHeading,
      applicationsDrawerContentLength: applicationsDrawerContent?.length || 0,
      applicationsDrawerContent
    });
  }, [isApplicationsDrawerOpen, applicationsDrawerHeading, applicationsDrawerContent]);

  useEffect(() => {
    setActiveLandingCard('changes');
  }, [viewType]);

  useEffect(() => {
    if ((activeLandingCard === 'conflicts' && conflictsTotal === 0) ||
        (activeLandingCard === 'incidents' && incidentsTotal === 0)) {
      setActiveLandingCard('changes');
    }
  }, [activeLandingCard, conflictsTotal, incidentsTotal]);

  // Handle clicks outside dropdowns
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (applicationViewDropdownRef.current && !applicationViewDropdownRef.current.contains(event.target)) {
        setApplicationViewDropdownOpen(false);
      }
      if (platformDropdownRef.current && !platformDropdownRef.current.contains(event.target)) {
        setPlatformDropdownOpen(false);
      }
      if (portfolioDropdownRef.current && !portfolioDropdownRef.current.contains(event.target)) {
        setPortfolioDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Handle input change for user search
  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputNameValue(value);
    setSuggestionClicked(false);
    
    // Clear suggestions immediately if input is too short
    if (value.length < 2) {
      setSuggestions(null);
    }
    else{
      fetchUserData(value);
    }
  };

  // Handle suggestion click
  // const handleSuggestionClick = (user) => {
  //   setInputNameValue(user.label);
  //   setInputNameValue1(user.value);
  //   setSelectedUser(user);
  //   setSuggestions([]);
  //   setSuggestionClicked(true);
  //   setEdit(false);
    
  //   // Reset platform and portfolio selections for new user
  //   setSelectedPlatform("");
  //   setSelectedPortfolio("");
    
  //   // Fetch data for selected user using their display name and email
  //   // In the new format: label is displayName, value is email
  //   getUserDetails(user.label, user.value);
  // };

  // Handle view type change (applications/platforms/portfolios)
  const handleViewTypeChange = (newViewType) => {
    setViewType(newViewType);
    // Update display data with the new view type
    updateDisplayData({
      data: apiData,
      currentViewType: newViewType
    });
  };

  // Handle platform selection
  const handlePlatformChange = async (platform) => {
    setSelectedPlatform(platform);
    setIsLoadingPlatformData(true);
    
    try {
      const result = await fetchSinglePlatformData(platform);
      if (result) {
        // Create the new data structure
        const newApiData = {
          ...apiData,
          platform_changes: {
            ...apiData.platform_changes,
            [platform]: result.data[platform]
          },
          platform_incidents: result.platform_incidents
        };
        // Update the apiData with new platform data
        setApiData(newApiData);
        
        // Update display data with the new platform data
        updateDisplayData({
          data: newApiData,
          currentViewType: viewType,
          currentTimeFilter: timeFilter,
          platformName: platform,
          portfolioName: selectedPortfolio,
          currentApplicationView: applicationView
        });
      }
    } catch (error) {
      console.error('Error fetching platform data:', error);
    } finally {
      setIsLoadingPlatformData(false);
    }
  };

  const handlePortfolioChange = async (portfolio) => {
    setSelectedPortfolio(portfolio);
    setIsLoadingPortfolioData(true);
    
    try {
      const result = await fetchSinglePortfolioData(portfolio);
      if (result && result.data) {
        console.log('Updating portfolio data:', portfolio, result.data);
        
        // Create the new data structure
        const newApiData = {
          ...apiData,
          portfolio_changes: {
            ...(apiData.portfolio_changes || {}),
            [portfolio]: result.data
          },
          portfolio_incidents: result.portfolio_incidents
        };
        
        // Update the apiData with new portfolio data
        setApiData(newApiData);
        
        // Update display data with the new portfolio data immediately
        updateDisplayData({
          data: newApiData,
          currentViewType: viewType,
          currentTimeFilter: timeFilter,
          platformName: selectedPlatform,
          portfolioName: portfolio,
          currentApplicationView: applicationView
        });
      }
    } catch (error) {
      console.error('Error fetching portfolio data:', error);
    } finally {
      setIsLoadingPortfolioData(false);
    }
  };

  // Handle time filter change
  const handleTimeFilterChange = (filter) => {
    setTimeFilter(filter);
    // Update display data with the new time filter
    updateDisplayData({
      data: apiData,
      currentViewType: viewType,
      currentTimeFilter: filter,
      platformName: selectedPlatform,
      portfolioName: selectedPortfolio,
      currentApplicationView: applicationView
    });
  };

  // Handle application view change
  const handleApplicationViewChange = (view) => {
    setApplicationView(view);
    setApplicationViewDropdownOpen(false); // Close dropdown after selection
    // Update display data with the new application view
    updateDisplayData({
      data: apiData,
      currentViewType: viewType,
      currentTimeFilter: timeFilter,
      platformName: selectedPlatform,
      portfolioName: selectedPortfolio,
      currentApplicationView: view
    });
  };

  // Handle dropdown toggle
  const handleApplicationViewDropdownToggle = () => {
    setApplicationViewDropdownOpen(!applicationViewDropdownOpen);
  };

  const handlePlatformDropdownToggle = () => {
    setPlatformDropdownOpen(!platformDropdownOpen);
  };

  const handlePortfolioDropdownToggle = () => {
    setPortfolioDropdownOpen(!portfolioDropdownOpen);
  };

  const handleApplicationsDrawerOpen = () => {   
    const result = generateApplicationsContent();
    
    if (result) {
      if (isApplicationsDrawerOpen) {
        setIsApplicationsDrawerOpen(false);
        setTimeout(() => {
          setApplicationsDrawerHeading(result.heading);
          setApplicationsDrawerContent(result.drawerContent);
          setIsApplicationsDrawerOpen(true);
        }, 100);
      } else {
        setApplicationsDrawerHeading(result.heading);
        setApplicationsDrawerContent(result.drawerContent);
        setIsApplicationsDrawerOpen(true);
      }
    }
  };

  const handleApplicationsDrawerClose = () => {
    setIsApplicationsDrawerOpen(false);
    setTimeout(() => {
      setApplicationsDrawerContent([]);
      setApplicationsDrawerHeading("");
      setSuggestions(null);
    }, 100);
  };

  /* const handleSubscriptionManagementLoadingChange = useCallback((loading) => {
    setIsSubscriptionManagementLoading(loading);
  }, []); */

  const handleChangeNumberClick = (changeNumber) => {
    if (changeNumber) {
      // Open change details in a new tab
      const url = `/change_details?changeNumber=${encodeURIComponent(changeNumber)}`;
      window.open(url, '_blank');
    }
  };

  const handleLandingCardChange = (cardKey) => {
    if (activeLandingCard === cardKey) {
      return;
    }

    setActiveLandingCard(cardKey);

    /* if (cardKey === 'subscriptions') {
      if (!shouldRenderSubscriptionManagement) {
        setShouldRenderSubscriptionManagement(true);
      }
      setIsSubscriptionManagementLoading(true);
    } */
  };

  const handleOnboardingViewClick = (request) => {
    console.log('View onboarding request:', request?.id);
  };

  const handleOnboardingCardClick = () => {
    if (onboardingRequestsCount > 0) {
      setActiveLandingCard('onboarding');
      window.open('/application-onboarding', '_blank');
    }
  };

  const renderRedChannelApplications = () => (
    <Box>
      <Typography sx={{ fontSize: '1.5rem', fontWeight: 600, color: '#dc2626', mb: 1, fontFamily: maerskFontFamily, textAlign: 'left' }}>
        Red Channel Applications
      </Typography>
      <Typography sx={{ color: '#6b7280', fontSize: '0.95rem', mb: 3, fontFamily: maerskFontFamily, textAlign: 'left' }}>
        Applications in Red Channel require immediate attention due to security or compliance issues.
      </Typography>
      {redChannelApplications.length === 0 ? (
        <Box sx={{ py: 4, textAlign: 'center' }}>
          <Typography sx={{ color: '#6b7280', fontFamily: maerskFontFamily }}>
            No applications in Red Channel.
          </Typography>
        </Box>
      ) : (
        <Box sx={{ display: 'grid', gap: 2 }}>
          {redChannelApplications.map((app) => (
          <Box
            key={app.id}
            sx={{
              p: 2.5,
              border: '2px solid #fecaca',
              borderRadius: 2,
              backgroundColor: '#fef2f2'
            }}
          >
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1.5 }}>
              <Box sx={{ flex: 1 }}>
                <Typography sx={{ fontSize: '1.1rem', fontWeight: 600, color: '#1f2937', fontFamily: maerskFontFamily }}>
                  {app.name}
                </Typography>
                <Typography sx={{ fontSize: '0.9rem', color: '#6b7280', fontFamily: maerskFontFamily, mt: 0.5 }}>
                  Application ID: {app.applicationId}
                </Typography>
              </Box>
              <Typography
                sx={{
                  px: 1.5,
                  py: 0.5,
                  borderRadius: '999px',
                  fontSize: '0.75rem',
                  fontWeight: 700,
                  backgroundColor: '#dc2626',
                  color: '#fff'
                }}
              >
                Red Channel
              </Typography>
            </Box>
            <Typography sx={{ fontSize: '0.85rem', color: '#991b1b', fontFamily: maerskFontFamily }}>
              This application requires immediate attention due to security or compliance issues.
            </Typography>
          </Box>
        ))}
        </Box>
      )}
    </Box>
  );

  const renderApplicationViewHeader = () => (
    <Box sx={{ mb: 3 }}>
      <Box
        ref={applicationViewDropdownRef}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          position: 'relative',
          fontFamily: maerskFontFamily,
          gap: 0.5
        }}
      >
        {edit ? (
          <>
            <Typography
              sx={{
                fontSize: '1rem',
                fontWeight: 600,
                color: '#111827',
                display: 'inline-flex',
                alignItems: 'center',
                cursor: 'pointer',
                fontFamily: maerskFontFamily,
                textAlign: 'center'
              }}
              onClick={handleApplicationViewDropdownToggle}
            >
              {currentApplicationViewLabel}
              {applicationViewDropdownOpen ? (
                <KeyboardArrowUpIcon fontSize="small" sx={{ ml: 0.5 }} />
              ) : (
                <KeyboardArrowDownIcon fontSize="small" sx={{ ml: 0.5 }} />
              )}
            </Typography>
            {applicationViewDropdownOpen && (
              <Box
                sx={{
                  position: 'absolute',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  top: '100%',
                  mt: 1,
                  bgcolor: 'white',
                  boxShadow: 3,
                  borderRadius: 1,
                  zIndex: 5000,
                  minWidth: 280,
                  maxHeight: 300,
                  overflowY: 'auto',
                  p: 1,
                  fontFamily: maerskFontFamily
                }}
                onClick={(e) => e.stopPropagation()}
              >
                {applicationViewOptions.map((option) => {
                  const isActive = applicationView === option.value;
                  return (
                    <Typography
                      key={option.value}
                      sx={{
                        px: 1,
                        py: 0.5,
                        color: isActive ? '#9ca3af' : '#111827',
                        cursor: isActive ? 'not-allowed' : 'pointer',
                        '&:hover': isActive ? {} : { bgcolor: '#f0f0f0' },
                        opacity: isActive ? 0.6 : 1,
                        fontFamily: maerskFontFamily,
                        textAlign: 'center',
                        width: '100%'
                      }}
                      onClick={() => {
                        if (!isActive) {
                          handleApplicationViewChange(option.value);
                        }
                      }}
                    >
                      {option.label}
                    </Typography>
                  );
                })}
              </Box>
            )}
            <Typography
              sx={{
                color: '#6b7280',
                fontSize: '0.8rem',
                fontFamily: maerskFontFamily,
                mt: 0.5,
                textAlign: 'center'
              }}
            >
              {applicationViewCopy}
            </Typography>
          </>
        ) : (<></>)}
      </Box>
      {/* <Typography
        sx={{
          color: '#6b7280',
          fontSize: '0.8rem',
          fontFamily: maerskFontFamily,
          mt: 0.5,
          textAlign: 'center'
        }}
      >
        {applicationViewCopy}
      </Typography> */}
    </Box>
  );

  const renderChangesDetailSection = () => (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <LandingPageTable
        data={tableDataForDisplay}
        Header1="Change Number"
        Header2="Configuration Item"
        Header3="Risk"
        Header4="Short Description"
        Header5="Planned Start Date"
        Header6="Planned End Date"
        Header7="State"
        Header8="Type"
        Header9="Assignment Group"
        Header10="Requested By"
        Header11="Close Code"
        setisdrawerOpen={setisdrawerOpen}
        setDrawerCi={setDrawerCi}
        setDrawerCiCategory={setDrawerCiCategory}
        setDrawerType={setDrawerType}
        setDrawerChange={setDrawerChange}
        isLoading={isLoadingData}
        timeFilter={timeFilter}
        timeFilterOptions={TIME_FILTER_OPTIONS}
        onTimeFilterChange={handleTimeFilterChange}
      />

      {/* <InsightsSidebar
        conflictPreviewGroups={conflictPreviewGroups}
        conflictingChangesTotal={conflictingChanges.total}
        onConflictShowMore={handleChangesDrawerOpen}
        onChangeNumberClick={handleChangeNumberClick}
        incidentTab={incidentTab}
        incidentLabelMap={incidentLabelMap}
        incidentCounts={incidentCounts}
        onIncidentTabChange={handleIncidentTabChange}
        incidentsDetail={incidentsDetail}
        onIncidentShowMore={handleIncidentsDrawerOpen}
        incidentsTotal={incidentsData.total}
      /> */}
    </Box>
  );

  const renderApplicationCardContent = () => {
    switch (activeLandingCard) {
      /* case 'onboarding':
        return (
          <Box>
            <Typography sx={{ fontSize: '1.5rem', fontWeight: 600, mb: 0.5, fontFamily: maerskFontFamily, textAlign: 'left' }}>
              My Onboarding Requests
            </Typography>
            <Typography sx={{ color: '#6b7280', fontSize: '0.95rem', mb: 3, fontFamily: maerskFontFamily, textAlign: 'left' }}>
              Review requests pending for your approval.
            </Typography>
            <LandingOnboardingRequestsTable
              requests={onboardingRequestsData}
              onViewClick={handleOnboardingViewClick}
            />
          </Box>
        ); */
      /* case 'subscriptions':
        return (
          <Box>
            <Typography sx={{ fontSize: '1.5rem', fontWeight: 600, mb: 0.5, fontFamily: maerskFontFamily, textAlign: 'left' }}>
              Subscription Management
            </Typography>
            <Typography sx={{ color: '#6b7280', fontSize: '0.95rem', mb: 3, fontFamily: maerskFontFamily, textAlign: 'left' }}>
              Manage your subscriptions and notification preferences across your applications.
            </Typography>
            {shouldRenderSubscriptionManagement ? (
              <>
                {isSubscriptionManagementLoading && (
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: 2,
                      minHeight: 320,
                      width: '100%'
                    }}
                  >
                    <CircularProgress />
                    <Typography sx={{ color: '#6b7280', fontFamily: maerskFontFamily }}>
                      Loading subscription details...
                    </Typography>
                  </Box>
                )}
                <Box sx={{ display: isSubscriptionManagementLoading ? 'none' : 'block', width: '100%' }}>
                  <SubscriptionManagement
                    onLoadingChange={handleSubscriptionManagementLoadingChange}
                    disableContainerStyles
                  />
                </Box>
              </>
            ) : (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  minHeight: 200,
                  textAlign: 'center',
                  width: '100%',
                  gap: 1
                }}
              >
                <Typography sx={{ color: '#6b7280', fontFamily: maerskFontFamily }}>
                  Select the subscriptions card to load your subscription preferences.
                </Typography>
              </Box>
            )}
          </Box>
        ); */
      case 'changes':
      default:
        return (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {renderApplicationViewHeader()}
            {renderChangesDetailSection()}
          </Box>
        );
    }
  };

  const handleChangesDrawerOpen = (changeType) => {
    if (!apiData) return;
    
    // Reset drawer state when opening
    setOriginalChangesContent(null);
    setOriginalChangesHeading("");
    setOriginalChangeType(changeType); // Store the change type

    // Generate content using the hook
    const result = generateChangesContent(changeType);
    
    if (result) {
      if (isChangesDrawerOpen) {
        setIsChangesDrawerOpen(false);
        setTimeout(() => {
          setChangesDrawerHeading(result.heading);
          setChangesDrawerContent(result.drawerContent);
          setIsChangesDrawerOpen(true);
        }, 100);
      } else {
        setChangesDrawerHeading(result.heading);
        setChangesDrawerContent(result.drawerContent);
        setIsChangesDrawerOpen(true);
      }
    }
  };

  const handleChangesDrawerClose = () => {
    setIsChangesDrawerOpen(false);
    // Reset drawer state
    setOriginalChangesContent(null);
    setOriginalChangesHeading("");
    setOriginalChangeType("");
    setTimeout(() => {
      setChangesDrawerContent([]);
      setChangesDrawerHeading("");
      setSuggestions(null);
    }, 100);
  };

  const handleIncidentsDrawerOpen = (incidentType) => {
    if (!apiData) return;
    
    // Generate content using the hook
    const result = generateIncidentsContent(incidentType);
    
    if (result) {
      if (isIncidentsDrawerOpen) {
        setIsIncidentsDrawerOpen(false);
        setTimeout(() => {
          setIncidentsDrawerHeading(result.heading);
          setIncidentsDrawerContent(result.drawerContent);
          setIsIncidentsDrawerOpen(true);
        }, 100);
      } else {
        setIncidentsDrawerHeading(result.heading);
        setIncidentsDrawerContent(result.drawerContent);
        setIsIncidentsDrawerOpen(true);
      }
    }
  };

  const handleIncidentsDrawerClose = () => {
    setIsIncidentsDrawerOpen(false);
    setTimeout(() => {
      setIncidentsDrawerContent([]);
      setIncidentsDrawerHeading("");
      setSuggestions(null);
    }, 100);
  };

  const handleIncidentsOverviewDrawerOpen = (initialTab = 'p1') => {
    const normalizedTab = incidentLabelMap[initialTab] ? initialTab : 'p1';
    setIncidentsOverviewTab(normalizedTab);
    setIsIncidentsOverviewDrawerOpen(true);
  };

  const handleIncidentsOverviewDrawerClose = () => {
    setIsIncidentsOverviewDrawerOpen(false);
  };

  const handleConflictsCardClick = () => {
    if (conflictsTotal <= 0) {
      return;
    }
    handleLandingCardChange('conflicts');
    handleChangesDrawerOpen('conflicts');
  };

  const handleIncidentsCardClick = () => {
    if (incidentsTotal <= 0) {
      return;
    }
    handleLandingCardChange('incidents');
    handleIncidentsOverviewDrawerOpen(incidentTab);
  };

  const handleRedChannelDrawerOpen = () => {
    if (redChannelAppsCount > 0) {
      setIsRedChannelDrawerOpen(true);
    }
  };

  const handleRedChannelDrawerClose = () => {
    setIsRedChannelDrawerOpen(false);
  };

  const handleRedChannelCardClick = () => {
    if (redChannelAppsCount > 0) {
      setActiveLandingCard('red-channel');
      handleRedChannelDrawerOpen();
    }
  };

  // Use the changes drawer hook
  const { handleChangesDrawerOpen: generateChangesContent } = useChangesDrawer(
    apiData,
    viewType,
    selectedPlatform,
    selectedPortfolio,
    applicationView,
    handleChangeNumberClick
  );

  // Use the applications drawer hook
  const { handleApplicationsDrawerOpen: generateApplicationsContent } = useApplicationsDrawer(
    userDetails,
    edit,
    inputNameValue1
  );
  const ref = useRef(null);
  // Use the incidents drawer hook
  const { handleIncidentsDrawerOpen: generateIncidentsContent } = useIncidentsDrawer(
    apiData,
    viewType,
    selectedPlatform,
    selectedPortfolio
  );
  const applicationViewOptions = getApplicationViewOptions(userDetails);
  const currentApplicationViewLabel =
    applicationViewOptions.find((option) => option.value === applicationView)?.label ||
    APPLICATION_VIEW_LABELS.consolidated;
  const applicationViewCopy = getApplicationOverviewCopy({
    edit,
    applicationView,
    userName: inputNameValue1
  });
  const { showBlank: shouldShowApplicationsBlankState, message: applicationsBlankMessage } =
    getApplicationsBlankState({
      viewType,
      applicationView,
      userDetails,
      edit,
      userName: inputNameValue1
    });

  useEffect(() => {
    console.log('Input name value changed:', inputNameValue);
  }, [inputNameValue]);


  return (
    <div className="LandingPage1">
      {/* Applications Drawer */}
      <ApplicationsDrawer
        isApplicationsDrawerOpen={isApplicationsDrawerOpen}
        applicationsDrawerHeading={applicationsDrawerHeading}
        applicationsDrawerContent={applicationsDrawerContent}
        onClose={handleApplicationsDrawerClose}
      />

      {/* Changes Drawer */}
      <ChangesDrawer
        isChangesDrawerOpen={isChangesDrawerOpen}
        changesDrawerHeading={changesDrawerHeading}
        changesDrawerContent={changesDrawerContent}
        onClose={handleChangesDrawerClose}
        apiData={apiData}
        viewType={viewType}
        selectedPlatform={selectedPlatform}
        onChangeNumberClick={handleChangeNumberClick}
      />

      {/* Incidents Drawer */}
      <IncidentsDrawer
        isIncidentsDrawerOpen={isIncidentsDrawerOpen}
        incidentsDrawerHeading={incidentsDrawerHeading}
        incidentsDrawerContent={incidentsDrawerContent}
        onClose={handleIncidentsDrawerClose}
      />

      {/* Incidents Overview Drawer */}
      <IncidentsOverviewDrawer
        open={isIncidentsOverviewDrawerOpen}
        onClose={handleIncidentsOverviewDrawerClose}
        incidentsDetail={incidentsDetail || {}}
        incidentCounts={incidentCounts}
        incidentLabelMap={incidentLabelMap}
        initialTab={incidentsOverviewTab}
      />

      {/* Red Channel Applications Drawer */}
      <RedChannelDrawer
        open={isRedChannelDrawerOpen}
        onClose={handleRedChannelDrawerClose}
        redChannelApplications={redChannelApplications}
      />
      
      {/* Drawer Components */}
      {isdrawerOpen && (
        drawerType === "ci_info" ? (
          <CiInfoDrawer
            isdrawerOpen={isdrawerOpen}
            setisdrawerOpen={setisdrawerOpen}
            drawerCi={drawerCi}
            drawerCiCategory={drawerCiCategory}
          />
        ) : drawerType === "change_details" ? (
            <ChangeDetailsDrawer
              isdrawerOpen={isdrawerOpen}
              setisdrawerOpen={setisdrawerOpen}
              drawerCi={drawerCi}
              drawerCiCategory={drawerCiCategory}
              drawerChange={drawerChange}
            />
          ) : (
            <DeploymentDetailsDrawer
              isdrawerOpen={isdrawerOpen}
              setisdrawerOpen={setisdrawerOpen}
              drawerCi={drawerCi}
              drawerCiCategory={drawerCiCategory}
              drawerChange={drawerChange}
            />
          )
      )}
      
      <div className="content-lp-wrapper">
        <div className="content-lp">
          <div className="content-lp-item">
            {edit ? (
              <>
                <div className={`transition-heading`}>My Changes Overview</div>
                {!(isLoadingData || spinnerDisplay) && (
                  <span
                    style={{
                      marginLeft: "8px",
                      cursor: "pointer"
                    }}
                    onClick={() => {
                      setEdit(false);
                      // Focus the typeahead input after a brief delay to ensure it's rendered
                      setTimeout(() => {
                        if (ref.current) {
                          ref.current.focus();
                        }
                      }, 100);
                    }}
                  >
                    <GoPencil size={20} title="Search for other users" />
                  </span>
                )}
              </>
            ) : (
              <>
                {
                  <>
                    <div
                      style={{
                        width: "300px",
                        display: "inline-block",
                        position: "relative",
                        marginLeft: "20px"
                      }}
                    >
                   { <McTypeahead
                      ref={ref}
                      showlistonfocus={true}
                      maxoptions="20"
                      data={suggestions}
                      debounce="600"
                      autoFocus
                      label=""
                      placeholder='Search for other users'
                      hiddenlabel={true}
                      clearbutton={true}
                      name="username"
                      input={(e)=>setInputNameValue(e.target.value)}
                      focus={(e) => console.log("Focus event:", e)}
                      blur={(e) => console.log("Blur event:", e)}
                      click={(e) => console.log("Click event:", e)}
                      keypress={(e) => console.log("KeyPress event:", e.key)}
                      search={async (e)=>{

                        if(e.target.value.length< 3){
                          return;
                        }
                        // Check if ref is still valid before proceeding
                        if (!ref.current) {
                          console.log('Ref is null, skipping search');
                          return;
                        }
                        
                        // Skip search if we're in the middle of a clear operation
                        if (isClearing) {
                          console.log('Currently clearing, skipping search');
                          return;
                        }
                      
                        ref.current.innerHTML = "";
                        ref.current.loading = true;
                        
                        try {
                          await fetchUserData(e.target.value);
                          
                        } catch (error) {
                          console.error('Error in fetchUserData:', error);
                        } finally {
                          // Always reset loading state if ref is still valid
                          if (ref.current) {
                            ref.current.loading = false;
                          }
                        }
                        
                        console.log('Input changed:', e.target.value);
                      }}
                      optionselected={async (e) => {
                        console.log('Option selected:', e.detail);
                        setTimeout(() => {
                          if (ref.current) {
                            ref.current.blur();
                            const inputElement = ref.current.querySelector('input');
                            if (inputElement) {
                              inputElement.blur();
                            }
                          }
                        }, 100);
                        setSuggestionClicked(true);
                        setInputNameValue(e.detail.label);
                        setInputNameValue1(e.detail.label);
                        setEdit(false);
                        setApplicationView("owned");
                        await getUserDetails(e.detail.label, e.detail.sublabel);
                        setSuggestions(null);
                      }}
                      
                      clearbuttonclick={async () => {
                        // Set clearing flag to prevent search events during clear operation
                        setIsClearing(true);
                        
                        setEdit(true);
                        setSpinnerDisplay(true);
                        setSuggestions(null);
                        setSuggestionClicked(false);
                        setApplicationView("consolidated");
                        
                        try {
                          // Reset to user's own data
                          setSelectedUser(null);
                          if (graphData?.displayName && graphData?.mail) {
                            setInputNameValue1(graphData.displayName);
                            await getUserDetails(graphData.displayName, graphData.mail);
                          }
                        } catch (error) {
                          console.error("Error resetting to user data:", error);
                        } finally {
                          setSpinnerDisplay(false);
                          // Reset loading state if ref is still valid
                          if (ref.current) {
                            ref.current.loading = false;
                          }
                          // Reset clearing flag after a short delay to ensure all events are processed
                          setTimeout(() => {
                            setIsClearing(false);
                          }, 100);
                        }
                      }}
                      optionsheight="200px"
                      minchars="3"
                      keepclearbuttonvisible
                      matchlabelonly
                      hint="Type a min of 3 characters to search"
                    />
}
                  
                      {/* <div
                        id="suggestion-container-lp"
                        style={{
                          width: "100%",
                          maxHeight: "100px",
                          backgroundColor: "white",
                          zIndex: 10,
                          position: "absolute",
                          display: (suggestions.length > 0 || isLoadingSuggestions) && !suggestionClicked ? "block" : "none",
                          borderTopLeftRadius: "0px",
                          overflowY: "auto",
                          textAlign: "left",
                          border: '1px solid #ccc',
                          borderTop: 'none',
                          borderRadius: '0 0 5px 5px'
                        }}
                      >
                        {isLoadingSuggestions ? (
                          <div
                            style={{
                              padding: '10px',
                              color: '#999',
                              cursor: 'default',
                            }}
                          >
                            Loading...
                          </div>
                        ) : (
                          suggestions.map((user, index) => (
                            <div
                              key={index}
                              className="suggestion-item-lp"
                              onClick={() => handleSuggestionClick(user)}
                              style={{
                                padding: '10px',
                                cursor: 'pointer',
                                borderBottom: index < suggestions.length - 1 ? '1px solid #eee' : 'none'
                              }}
                            >
                              <strong>{user.displayName}</strong>
                              <br />
                              <small>{user.email}</small>
                            </div>
                          ))
                        )}
                      </div> */}
                    </div>
                    {/* <MdOutlineCancel
                      size={20}
                      style={{ marginLeft: "5px", cursor: "pointer" }}
                      onClick={async () => {
                        setEdit(true);
                        setSpinnerDisplay(true);
                        setInputNameValue("");
                        setInputNameValue1("");
                        setSuggestions([]);
                        setSuggestionClicked(false);
                        
                        try {
                          // Reset to user's own data
                          setSelectedUser(null);
                          if (graphData?.displayName && graphData?.mail) {
                            await getUserDetails(graphData.displayName, graphData.mail);
                          }
                        } catch (error) {
                          console.error("Error resetting to user data:", error);
                        } finally {
                          setSpinnerDisplay(false);
                        }
                      }}
                    /> */}
                  </>
                }
              </>
            )}
          </div>

          {/* Loading State */}
          {(isLoadingData || spinnerDisplay) ? (
            <div style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center',
              marginTop: '50px'
            }}>
              <CircularProgress />
            </div>
          ) : (
            <>
              {/* View Type Tabs */}
              <div className="content-lp-item">
                <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap' }}>
                  <McTabBar 
                    tabchange={(e) => handleViewTypeChange(
                      e.detail === 0 ? "applications" : 
                      e.detail === 1 ? "platforms" : "portfolios"
                    )} 
                    currentindex={
                      viewType === "applications" ? 0 : 
                      viewType === "platforms" ? 1 : 2
                    }
                    style={{ flex: '1', minWidth: '0' }}
                  >
                    <McTab 
                      slot="tab" 
                      label={edit ? "My Activity" : "User's Activity"} 
                      active={viewType === "applications"}
                      style={{ display: 'inline-flex', alignItems: 'center', whiteSpace: 'nowrap' }}
                    >
                      {/* <span slot="suffix" style={{ display: 'inline-flex', alignItems: 'center' }}>
                        <div
                          style={{ 
                            cursor: 'pointer', 
                            display: 'inline-flex',
                            alignItems: 'center',
                            padding: '2px',
                            borderRadius: '4px'
                          }}
                          onClick={(e) => {
                            console.log('Chip clicked!');
                            e.stopPropagation();
                            e.preventDefault();
                            handleApplicationsDrawerOpen();
                          }}
                          onMouseDown={(e) => {
                            e.stopPropagation();
                          }}
                        >
                          
                        </div>
                      </span> */}
                    </McTab>
                    <div slot="panel"></div>
                    <McTab 
                      slot="tab" 
                      label={edit ? "My Platform" : "Platform"} 
                      active={viewType === "platforms"}
                      style={{ whiteSpace: 'nowrap' }}
                    ></McTab>
                    <div slot="panel"></div>
                    <McTab 
                      slot="tab" 
                      label={edit ? "My Portfolio" : "Portfolio"} 
                      active={viewType === "portfolios"}
                      style={{ whiteSpace: 'nowrap' }}
                    ></McTab>
                    <div slot="panel"></div>
                  </McTabBar>
                </div>
              </div>

              {/* Platform Selection (only shown when platform view is selected) */}
              {viewType === "platforms" && (
                <div className="content-lp-item" style={{ marginBottom: 20 }}>
                  <Box sx={{ textAlign: "center", position: "relative", marginBottom: 1 }} ref={platformDropdownRef}>
                    {userDetails.platforms.length > 1 ? (
                      <>
                        <Typography
                          variant="body1"
                          sx={{
                            fontWeight: "600",
                            color: "#333",
                            display: "inline-flex",
                            alignItems: "center",
                            cursor: "pointer",
                            fontSize: '1rem',
                            fontFamily: maerskFontFamily
                          }}
                          onClick={handlePlatformDropdownToggle}
                        >
                          {selectedPlatform || "Select a platform"}
                          {platformDropdownOpen ? (
                            <KeyboardArrowUpIcon fontSize="small" sx={{ ml: 0.5 }} />
                          ) : (
                            <KeyboardArrowDownIcon fontSize="small" sx={{ ml: 0.5 }} />
                          )}
                        </Typography>
                        {platformDropdownOpen && (
                          <Box
                            sx={{
                              position: "absolute",
                              left: "50%",
                              transform: "translateX(-50%)",
                              top: "100%",
                              mt: 1,
                              bgcolor: "white",
                              boxShadow: 3,
                              borderRadius: 1,
                              zIndex: 5000,
                              minWidth: 300,
                              maxHeight: 200,
                              overflowY: "auto",
                              p: 1,
                              fontFamily: maerskFontFamily
                            }}
                            onClick={(e) => e.stopPropagation()}
                          >
                            {userDetails.platforms.map((platform, index) => (
                              <Typography
                                key={index}
                                // variant="body2"
                                sx={{
                                  px: 1,
                                  py: 0.5,
                                  color: platform === selectedPlatform ? "#aaa" : "#333",
                                  cursor: platform === selectedPlatform ? "not-allowed" : "pointer",
                                  "&:hover": platform === selectedPlatform ? {} : { bgcolor: "#f0f0f0" },
                                  opacity: platform === selectedPlatform ? 0.6 : 1,
                                  textAlign: "left",
                                  fontFamily: maerskFontFamily
                                }}
                                onClick={() => {
                                  if (platform !== selectedPlatform) {
                                    handlePlatformChange(platform);
                                    setPlatformDropdownOpen(false);
                                  }
                                }}
                              >
                                {platform}
                              </Typography>
                            ))}
                          </Box>
                        )}
                      </>
                    ) : (
                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: "600",
                          color: "#333",
                          fontSize: '1rem',
                          fontFamily: maerskFontFamily
                        }}
                      >
                        {selectedPlatform || userDetails.platforms[0] || "No platform available"}
                      </Typography>
                    )}
                  </Box>
                  {/* <div>
                    {edit
                    ? "This is a comprehensive overview of the Changes occurring in the platform you are a part of."
                    : `This is a comprehensive overview of the Changes occurring in the platform ${inputNameValue1} is a part of.`}
                  </div> */}
                </div>
              )}

              {/* Portfolio Selection (only shown when portfolio view is selected) */}
              {viewType === "portfolios" && (
                <div className="content-lp-item" style={{ marginBottom: 20 }}>
                  <Box sx={{ textAlign: "center", position: "relative", marginBottom: 1 }} ref={portfolioDropdownRef}>
                    {userDetails.portfolios.length > 1 ? (
                      <>
                        <Typography
                          variant="body1"
                          sx={{
                            fontWeight: "600",
                            color: "#333",
                            display: "inline-flex",
                            alignItems: "center",
                            cursor: "pointer",
                            fontSize: '1rem',
                            fontFamily: maerskFontFamily
                          }}
                          onClick={handlePortfolioDropdownToggle}
                        >
                          {selectedPortfolio || "Select a portfolio"}
                          {portfolioDropdownOpen ? (
                            <KeyboardArrowUpIcon fontSize="small" sx={{ ml: 0.5 }} />
                          ) : (
                            <KeyboardArrowDownIcon fontSize="small" sx={{ ml: 0.5 }} />
                          )}
                        </Typography>
                        {portfolioDropdownOpen && (
                          <Box
                            sx={{
                              position: "absolute",
                              left: "50%",
                              transform: "translateX(-50%)",
                              top: "100%",
                              mt: 1,
                              bgcolor: "white",
                              boxShadow: 3,
                              borderRadius: 1,
                              zIndex: 5000,
                              minWidth: 300,
                              maxHeight: 200,
                              overflowY: "auto",
                              p: 1,
                              fontFamily: maerskFontFamily
                            }}
                            onClick={(e) => e.stopPropagation()}
                          >
                            {userDetails.portfolios.map((portfolio, index) => (
                              <Typography
                                key={index}
                                // variant="body2"
                                sx={{
                                  px: 1,
                                  py: 0.5,
                                  color: portfolio === selectedPortfolio ? "#aaa" : "#333",
                                  cursor: portfolio === selectedPortfolio ? "not-allowed" : "pointer",
                                  "&:hover": portfolio === selectedPortfolio ? {} : { bgcolor: "#f0f0f0" },
                                  opacity: portfolio === selectedPortfolio ? 0.6 : 1,
                                  textAlign: "left",
                                  fontFamily: maerskFontFamily
                                }}
                                onClick={() => {
                                  if (portfolio !== selectedPortfolio) {
                                    handlePortfolioChange(portfolio);
                                    setPortfolioDropdownOpen(false);
                                  }
                                }}
                              >
                                {portfolio}
                              </Typography>
                            ))}
                          </Box>
                        )}
                      </>
                    ) : (
                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: "600",
                          color: "#333",
                          fontSize: '1rem',
                          fontFamily: maerskFontFamily
                        }}
                      >
                        {selectedPortfolio || userDetails.portfolios[0] || "No portfolio available"}
                      </Typography>
                    )}
                  </Box>
                  {/* <div>
                    {edit
                    ? "This is a comprehensive overview of the Changes occurring in the portfolio you are a part of."
                    : `This is a comprehensive overview of the Changes occurring in the portfolio ${inputNameValue1} is a part of.`}
                  </div> */}
                </div>
              )}

              

              {/* Suppress blank-state message to keep dashboard visible even with zero applications */}

              {(isLoadingPortfolioData || isLoadingPlatformData) ? (
                <Box sx={{ 
                  display: 'flex', 
                  justifyContent: 'center', 
                  alignItems: 'center',
                  width: '100%',
                  marginTop: "50px"
                }}>
                  <CircularProgress />
                </Box>
              ) : (
                <>
                      {/* Charts Section - Card Based Layout */}
                      <div className="content-lp-item" style={{ marginBottom: '0px' }}>
                        <div
                          style={{
                            marginTop: "0px",
                          }}
                        >
                      <Box 
                        sx={{ 
                          display: 'flex', 
                          flexWrap: 'wrap', 
                          gap: 2, 
                          justifyContent: 'center', 
                          marginBottom: "40px" 
                        }}
                      >
                        <Box
                          sx={{
                            flex: '1',
                            minWidth: 260,
                            ...(viewType !== 'applications' && { display: 'flex' })
                          }}
                        >
                          <ChangeSummaryCard
                            title={changeCardTitle}
                            subtitle={changeCardSubtitle}
                            totalChanges={successRate.total}
                            successCount={successRate.success}
                            inProgressCount={successRate.ongoing}
                            failureCount={successRate.failure}
                            overdueCount={overdueChanges.overdue}
                            conflictCount={conflictingChanges.total}
                            incidentsCount={incidentsData.total}
                            isLoading={isLoadingData}
                            onCategoryClick={handleChangesDrawerOpen}
                            onOverdueClick={handleChangesDrawerOpen}
                            onConflictsClick={() => handleChangesDrawerOpen('conflicts')}
                            onIncidentsClick={() => handleIncidentsOverviewDrawerOpen(incidentTab)}
                            isActive={activeLandingCard === 'changes'}
                            isInteractive={isChangeCardInteractive}
                            onCardClick={() => handleLandingCardChange('changes')}
                            showStatusPills={viewType === 'applications'}
                          />
                        </Box>
                        {viewType === 'applications' ? (
                          <>
                            <Box sx={{ flex: '1', minWidth: 260 }}>
                              <LandingDashboardCard
                                icon={<McIcon icon="shield-check" size="24" />}
                                title="ONBOARDING REQUESTS"
                                count={onboardingRequestsCount}
                                subtitle="Requests pending for your approval"
                                isActive={activeLandingCard === 'onboarding'}
                                onClick={canOpenOnboardingCard ? handleOnboardingCardClick : undefined}
                                iconColor="#ede9fe"
                                iconTint="#dcfce7"
                              />
                            </Box>
                            {/* <Box sx={{ flex: '1', minWidth: 260 }}>
                              <LandingDashboardCard
                                icon={<McIcon icon="bell" size="24" />}
                                title="MY SUBSCRIPTIONS"
                                count={subscribedAppsCount}
                                subtitle="Subscribed applications"
                                badgeCount={subscriptionListsCount}
                                badgeLabel="Lists"
                                isActive={activeLandingCard === 'subscriptions'}
                                onClick={() => handleLandingCardChange('subscriptions')}
                                iconColor="#ede9fe"
                                iconTint="#ede9fe"
                              />
                            </Box> */}
                            <Box sx={{ flex: '1', minWidth: 260 }}>
                              <LandingDashboardCard
                                icon={<McIcon icon="exclamation-triangle" size="24" />}
                                title="RED CHANNEL APPLICATIONS"
                                count={redChannelAppsCount}
                                subtitle="Applications in Red Channel"
                                isActive={activeLandingCard === 'red-channel'}
                                onClick={redChannelAppsCount > 0 ? handleRedChannelCardClick : undefined}
                                countColor={redChannelAppsCount > 0 ? '#f44336' : '#4caf50'}
                                iconColor="#dcfce7"
                                iconTint="#fee2e2"
                              />
                            </Box>
                          </>
                        ) : (
                          <>
                            <Box sx={{ flex: '1', minWidth: 260, display: 'flex' }}>
                              <ConflictsSummaryCard
                                title="CONFLICTING CHANGES"
                                conflictCount={conflictsTotal}
                                isLoading={isLoadingData}
                                onCardClick={handleConflictsCardClick}
                                isActive={activeLandingCard === 'conflicts'}
                              />
                            </Box>
                            <Box sx={{ flex: '1', minWidth: 260, display: 'flex' }}>
                              <IncidentsSummaryCard
                                title="INCIDENTS DUE TO CHANGES"
                                incidentsTotal={incidentsTotal}
                                incidentsBreakdown={incidentCounts}
                                isLoading={isLoadingData}
                                onCardClick={handleIncidentsCardClick}
                                isActive={activeLandingCard === 'incidents'}
                              />
                            </Box>
                          </>
                        )}
                      </Box>
                    </div>
                  </div>
                  {/* Table Section followed by Insights */}
                  <div className="content-lp-item">
                    {viewType === "applications" ? renderApplicationCardContent() : renderChangesDetailSection()}
                  </div>
                  <Box style={{ marginTop: "8vh", visibility: "hidden" }}>
                      ""
                  </Box>
                </>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
